import { Injectable } from "@angular/core";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { TranslocoService } from "@jsverse/transloco";

@Injectable({
    providedIn: "root",
})
export class MatPaginatorIntlCustomService extends MatPaginatorIntl {
    private rangeLabel = "";
    private itemsLabel = "";

    public constructor(private translocoService: TranslocoService) {
        super();
        this.translocoService.langChanges$.subscribe(() =>
            this.changeLanguage(),
        );
    }

    public changeLanguage(): void {
        this.translocoService
            .selectTranslateObject("paginator")
            .subscribe((data) => {
                this.itemsPerPageLabel = data.records_per_page;
                this.firstPageLabel = data.first_page;
                this.previousPageLabel = data.previous_page;
                this.nextPageLabel = data.next_page;
                this.lastPageLabel = data.last_page;
                this.rangeLabel = data.range_label;
                this.itemsLabel = data.items_label;
                this.updateRangeLabelFunction();
                this.changes.next();
            });
    }

    private updateRangeLabelFunction(): void {
        this.getRangeLabel = (
            page: number,
            pageSize: number,
            length: number,
        ): string => {
            if (length === 0 || pageSize === 0) {
                return `0 ${this.rangeLabel} ${length} ${this.itemsLabel}`;
            }

            length = Math.max(length, 0);

            const startIndex: number = page * pageSize;
            const endIndex: number =
                startIndex < length
                    ? Math.min(startIndex + pageSize, length)
                    : startIndex + pageSize;

            return `${startIndex + 1} - ${endIndex} ${
                this.rangeLabel
            } ${length} ${this.itemsLabel}`;
        };
    }
}
